import axios from "axios";

export async function updateInitialGroupByName(groupName) {
  try {
    const tokenDetailsString = localStorage.getItem("userDetails");
    const tokenDetails = JSON.parse(tokenDetailsString);
    const token = tokenDetails.token;
    const userId = tokenDetails.data.id;

    const response = await axios.patch(
      `${process.env.REACT_APP_PREDICTIONS_API}/api/updateInitialGroup`,
      { userId: userId, initialGroup: groupName },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status === 200) {
      localStorage.setItem("user_initial_Group", groupName);

    } else {
      console.error("Error updating user initialGroup");
    }
  } catch (error) {
    console.error("Error updating user initialGroup:", error);
  }
}
